//
//
//
//
//
//

import Questionnaire from '@/views/zhongshan/components/Questionnaire'
import { mapGetters, mapActions } from 'vuex'
import { MIN_USE_TIME } from '@/utils/constant'

export default {
  name: 'Layout',
  components: {
    Questionnaire
  },
  data() {
    return {
      timeout: null
    }
  },
  methods: {
    useTimer() {
      // 用户有点击使用后开始统计使用时间，超过15秒后就弹出调查问卷
      // 已经弹出过调查问卷窗口，24h则不再弹出
      if (this.timeout === null && !this.hasShowQuestionnaire) {
        // TODO：关闭调查问卷，与小程序不兼容
        this.timeout = setTimeout(this.openQuestionnaireDialog, MIN_USE_TIME)
      }
    },
    ...mapActions([
      'openQuestionnaireDialog'
    ]),
  },
  computed: {
    ...mapGetters([
      'hasShowQuestionnaire',
      'showQuestionnaire'
    ])
  }
}



// WEBPACK FOOTER //
// ./src/views/zhongshan/index.vue